module.exports = __webpack_public_path__ + "static/media/pic.b0febe11.jpg";